




















































import Vue from 'vue';
import {ApolloError, ApolloQueryResult} from 'apollo-client';

import {Asset, RouteNames} from '@/typings/types';
import {getAllAssets} from '@/backend/queries/graph-cms-queries';


export default Vue.extend({
  name: 'gallery-component',

  data () {
    return {
      RouteNames,
      assets: <Asset[]> [],
      loading: true,
      error: false,
    };
  },

  apollo: {
    assets: {
      query: getAllAssets,
      result ({data}: ApolloQueryResult<Dict>) {
        this.loading = false;
        this.assets = data.assets;
      },
      error (apolloError: ApolloError) {
        // eslint-disable-next-line no-console
        console.log('apolloError', apolloError);

        this.loading = false;
        this.error = true;
      },
    },
  },
});
